import { DeliveryType, NotificationContent } from '../Notifications'
import { ErrData, ILambdaLogger, ValidBusinessObject } from '@iotv/iotv-v3-types'

export type ScheduledReportsEvent = {
  generatorId: string
  userSk: string
  inputs: { [inputName: string]: string | number | ValidBusinessObject }
}

/** The object that is actually given to the scheduled reprots lambda */
export type ReportGeneratorInputObject = { [inputName: string]: string | number | ValidBusinessObject }

/** These types are to do with the setting up of a report schedule */
export enum ReportGeneratorSetupInputEnum {
  GROUP = 'group',
  VALIDBUSINESSOBJECT = 'ValidBusinessObject',
  STRING = 'string',
  NUMBER = 'number',
}

/** This type is used to specify type of inputs. It's used by ReportSetUpCard to query properly for given inputs */
export type ReportGeneratorSetupInput = {
  label: string
  key: string
  description?: string
} & (
  | {
      type: { inputType: ReportGeneratorSetupInputEnum.GROUP; supportedType: string }
      validator?: (input: ValidBusinessObject) => { valid: boolean; reason: string }
    }
  | {
      type: { inputType: ReportGeneratorSetupInputEnum.VALIDBUSINESSOBJECT; vobType: string }
      validator?: (input: ValidBusinessObject) => { valid: boolean; reason: string }
    }
  | {
      type: { inputType: ReportGeneratorSetupInputEnum.STRING; string: string }
      validator?: (input: string) => { valid: boolean; reason: string }
    }
  | {
      type: { inputType: ReportGeneratorSetupInputEnum.NUMBER; number: number }
      validator?: (input: number) => { valid: boolean; reason: string }
    }
)

export enum ScheduledReportPeriodUnits {
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
  //MONTH = 'month',
}

export type ReportGeneratorBundle<T extends ReportGeneratorInputObject> = {
  id: string
  inputs: ReportGeneratorSetupInput[]
  generatorFn: ReportGenerator<T>

  definedPeriodWidth?: number // Enforced for users if present
  definedPeriodUnit?: ScheduledReportPeriodUnits // Enforced for users if present
  definedStartDate?: string // cron expression string - see https://crontab.cronhub.io/. For users, report start date will be next date that fulfills cron expression (if definedStartDate is present)
}

export type ReportGeneratorOutput = {
  deliveryType: DeliveryType.EMAIL | DeliveryType.RAWEMAIL
  notificationContent: NotificationContent
}

export type ReportGenerator<T> = (inputs: T, userSk: string, logger?: ILambdaLogger) => Promise<ErrData<ReportGeneratorOutput>>
